import { Component } from "../../../../modules/Core/Component";
import templateDefault from "../../../templates/default/widgets/sliders/top_banners_slider";
import Services from "../../../Services/Services";

export default class TopBannersSlider extends Component {
  id = "main-slider";
  interval;

  template = templateDefault;

  onLoad(data) {
    super.onLoad(data);

    this.getSliders();
  }

  getSliders() {
    Services.get("hook").then(async ([hookService]) => {
      try {
        var response = await hookService.exec("statics", {
          params: { scope: this.props.fscope },
        });

        const sliders = response.getData() || [];

        this.startInterval(sliders, 0);

        this.setData({
          "default.sliders": sliders,
        });
      } catch (e) {
        console.log(e);
      }
    });
  }

  startInterval(sliders, activeSlide) {
    clearInterval(this.interval);
    this.setData({
      "default.active_slide": activeSlide,
    });
    this.interval = setInterval(() => {
      this.setData({
        "default.active_slide": ++activeSlide % sliders.length,
      });
    }, 9000);
  }
}
